import React from 'react';
import PropTypes from 'prop-types';

import BookingOverviewGuestsContainer from '../../containers/BookingOverviewGuestsContainer';
import BookingOverviewDates from './BookingOverviewDates';

const BookingOverviewMetadata = props => (
  <section className="booking-overview__guests-and-dates booking-overview__section">
    <BookingOverviewGuestsContainer
      actions={props.actions}
      appearance={props.appearance}
      errors={props.errors}
      order={props.order}
      rental={props.rental}
    />
    <BookingOverviewDates arrivalDate={props.order.localizedArrivalDate} departureDate={props.order.localizedDepartureDate} />
  </section>
);

BookingOverviewMetadata.PropTypes = {
  order:PropTypes.object.isRequired,
  rental:PropTypes.object.isRequired,
  errors:PropTypes.object.isRequired,
  actions:PropTypes.object.isRequired,
  appearance:PropTypes.object.isRequired,
};

export default BookingOverviewMetadata;
